import { AsyncPipe, DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { CompetitionEvent, EventType } from 'src/app/models/competitionEvent';
import { CompetitionEventsService } from 'src/app/services/competition-events.service';

@Component({
    selector: 'app-competition-table',
    imports: [NgIf, NgFor, NgSwitch, NgSwitchCase, DatePipe, AsyncPipe, RouterLink],
    templateUrl: './competition-table.component.html',
    styleUrl: './competition-table.component.scss'
})
export class CompetitionTableComponent {

  public events$ : Observable<CompetitionEvent[]>;

  public EventType = EventType;

  constructor(calendarService: CompetitionEventsService) {
    this.events$ = calendarService.getUpcomingEvents(1, 5);
  }
}
